// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

import { generalConstants } from '@lfx/config';

/**
 * Email validation utilities using the app's shared email regex.
 * Requires a valid TLD (at least 2 alphabetic characters).
 */
export class EmailValidator {
  /**
   * Validates if a string is a valid email address.
   * Uses generalConstants.emailRegex for consistency across the app.
   *
   * @param value - The string to validate
   * @returns true if the value is a valid email, false otherwise
   */
  static isValidEmail(value: string | null | undefined): boolean {
    if (!value || typeof value !== 'string') {
      return false;
    }

    const trimmed = value.trim();
    if (!trimmed) {
      return false;
    }

    return generalConstants.emailRegex.test(trimmed);
  }
}
